(function(){
  var pill=document.querySelector('.pp__status');
  if(!pill)return;
  var m=location.pathname.match(/\/products\/([^\/?#]+)/);
  if(!m)return;
  var handle=m[1];
  var MAP={
    'arc-raiders-access-key':'division arc raiders key',
    'rust':'division rust key',
    'fortnite':'division fortnite key',
    'tcr6':'division rainbow six key',
    'apxl':'division apex legends key',
    'division-delta-force':'division delta force key',
    'division-hell-let-loose':'division hell let loose key',
    'division-marvel-rivals':'division marvel rivals key',
    'division-squad':'division squad key',
    'division-dead-by-daylight':'division dead by daylight key',
    'division-deadlock':'division deadlock key',
    'division-pubg':'division pubg',
    'division-overwatch':'overwatch',
    'division-wardogs':'division wardogs'
  };
  var want=MAP[handle];
  var LBL={safe:'Safe',risky:'Risky',unsafe:'Unsafe',testing:'Updating'};
  var COL={safe:'#3ddc97',risky:'#f5c542',unsafe:'#ff4d4d',testing:'#6aa8ff'};
  var css=document.createElement('style');
  css.textContent='.pp__status.is-synced{font-weight:700;color:var(--c)!important;background:color-mix(in srgb,var(--c) 14%,transparent)!important;border:1px solid color-mix(in srgb,var(--c) 45%,transparent)!important}.pp__status.is-synced i{background:var(--c)!important;box-shadow:0 0 8px var(--c)!important}.pp__status.is-wait{visibility:hidden}';
  document.head.appendChild(css);
  if(!want){pill.style.display='none';return}
  pill.classList.add('is-wait');
  function apply(st){
    if(!LBL[st]){pill.style.display='none';return}
    pill.style.setProperty('--c',COL[st]);
    pill.classList.add('is-synced');
    pill.innerHTML='<i></i>'+LBL[st];
    pill.classList.remove('is-wait');
  }
  function norm(s){return String(s||'').toLowerCase().replace(/\s+/g,' ').trim()}
  var KEY='gstat:'+want,cached=null;
  try{var c=JSON.parse(sessionStorage.getItem(KEY)||'null');if(c&&Date.now()-c.t<60000)cached=c.s}catch(e){}
  if(cached){apply(cached);return}
  fetch('/pages/status',{credentials:'same-origin'}).then(function(r){return r.text()}).then(function(h){
    var doc=new DOMParser().parseFromString(h,'text/html'),found=null;
    doc.querySelectorAll('.es__card').forEach(function(c){if(norm(c.getAttribute('data-name'))===want)found=c.getAttribute('data-st')});
    if(found){try{sessionStorage.setItem(KEY,JSON.stringify({t:Date.now(),s:found}))}catch(e){}}
    apply(found);
  }).catch(function(){pill.style.display='none'});
})();
